export default __webpack_public_path__ + "static/media/stay.e3f0116a.svg";